import {
  Content,
  SelectItem,
  SelectScrollDownButton,
  SelectScrollUpButton,
  Trigger
} from './components'
import { Viewport } from './primitives'
import { Select as Root } from './Select'

export const Select = {
  Root,
  Trigger,
  Content,
  Viewport,
  SelectItem,
  SelectScrollUpButton,
  SelectScrollDownButton
}
